import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const HeaderLogo = (props) => {
  const theme = useTheme();
	return (
		<Link href="/" height="100%" sx={{ display: "flex", underline: "none" }}>
      <Box component="img" height="100%" src="/logo.svg" alt="Guessaulenko"
        sx={{ filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none' }} />
		</Link>
	);
};

export default HeaderLogo;
